import { Box, useTheme } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
// import { tokens } from "../../../../../../theme";
import { tokens } from "../../../../../../theme";

import ShTextSkeleton from "../../../../../../components/theme/skeleton/ShTextSkeleton";

import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from "react-i18next";
import MAddCountingStrategy from "../../../../../../components/global/Modals/MAddCountingStrategy";
import ButtonGroup from "../../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../../components/theme/datagrid2/ShDataGrid2";
import { useGetCountingStrategyTemplatesQuery } from "../../../../../../newapi/countingstrategy/countingStrategyTemplateSlice";
import SidepanelLoader from "../../../../../../components/theme/sidepanel2/SidepanelLoader";
import { selectUserPermission } from "../../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../../utils/permissions";
import { useSelector } from "react-redux";
import { getCountingStategyLabelData } from "../../../../../../utils/labelColorText";
import ShLabel from "../../../../../../components/theme/label/ShLabel";
import Text from "../../../../../../components/theme/text/Text";
import  SettingsWarehouseCountingStrategyCard  from "../../../../../../components/global/cards/settings/SettingsWarehouseCountingStrategyCard";

const SpCountingStrategyTemplateDetails = SidepanelLoader(() => import("../../../../../../components/global/Sidepanels/SpCountingStrategyTemplateDetails/SpCountingStrategyTemplateDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    useEffect(() => {},[props.open]);

    const {t} = useTranslation();
    return (      
        <ButtonGroup version={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>{t("new_counting_strategy")}</Shbutton>
            )}
        </ButtonGroup>
    )
}

const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};

const All = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended,setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.COUNTINGSTRATEGYTEMPLATE_MANAGE])
    );

    const [strategyId, setStrategyId] = useState();
    const strategyIdRef = useRef(strategyId);

    
    const getStrategyDetails = (params) => {
        if (!params) return;
    
        const newStrategyId = parseInt(params.row.id);
        // Only update state if the productId has actually changed
        if (strategyIdRef.current !== newStrategyId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setStrategyId(newStrategyId);
            strategyIdRef.current = newStrategyId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
      };


    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[hasCreatePermission,setAddModalOpen]);
    
    const columns = [
        {
            field: "name",
            headerName: t("name"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return <Text semibold>{params.row.name}</Text>
            }
        },
        {
            field: "type",
            headerName: t("type"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                const {labeltext, labelcolor} = getCountingStategyLabelData(params.row.type,theme);
                
                return (
                    <ShLabel
                        clickable
                        variant={labelcolor}
                        fitted
                        size={32} 
                        palette="normal" 
                    >
                        {t(labeltext)}
                    </ShLabel>
                );
            },
        },
        {
            field: "frequency",
            headerName: t("frequency"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return t(params.row.frequency);
            },
        },
        {
            field: "amount",
            headerName: t("amount"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return `${params.row.amount}%`;
            },
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {

                return (
                    <SettingsWarehouseCountingStrategyCard
                        skeleton={cellValues.row.skeleton ?? false}
                        {...cellValues.row}
                        onClick={() => getStrategyDetails(cellValues)}
                    />
                )
            }
        }
    ];

    
    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            
            {/* <GridActions></GridActions> */}
            
            <ShDataGrid2
                content={useGetCountingStrategyTemplatesQuery}
                gridActions={<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>} 
                title={t("overview")}
                gridOptions={gridOptions} 
                
                sortModel={{field: columns[0].field,type:"ASC"}}
                columns={columns} 
                onRowClick={getStrategyDetails}>
            </ShDataGrid2>
            

            <MAddCountingStrategy onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose}/>
            {spLoading && 
                <SpCountingStrategyTemplateDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    strategyId={strategyId}      
                /> 
            }
        </Box>
    )
};

export default All;